import { Component } from '@angular/core';
import { AppSettings } from './appSettings';
import { DOCUMENT } from '@angular/common';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent {
  title = 'SegCommerce - Painel de configuração';
  settings = new AppSettings(document);
}
